// Use this module if you want to lazy load (split out) SVG icons only! Otherwise directly import them.
import React from 'react';
import loadable from '@loadable/component';

const AccountSvg = loadable(() => import(`./Svgs/Account`));
const ArrowSvg = loadable(() => import(`./Svgs/Arrow`));
const CartSvg = loadable(() => import(`./Svgs/Cart`));
const CategoriesSvg = loadable(() => import(`./Svgs/Categories`));
const FacebookSvg = loadable(() => import(`./Svgs/Facebook`));
const Facebook2Svg = loadable(() => import(`./Svgs/Facebook2`));
const InteriorServiceSvg = loadable(() => import(`./Svgs/InteriorService`));
const LooksSvg = loadable(() => import(`./Svgs/Looks`));
const ProductFilterSvg = loadable(() => import(`./Svgs/ProductFilter`));
const ProductSortBySvg = loadable(() => import(`./Svgs/ProductSortBy`));
const SalesSvg = loadable(() => import(`./Svgs/Sales`));
const SearchSvg = loadable(() => import(`./Svgs/Search`));
const SearchSvg2 = loadable(() => import(`./Svgs/v2/Search`));
const NewSearch = loadable(() => import(`./Svgs/v2/NewSearch`));
const Instagram = loadable(() => import(`./Svgs/Instagram`));
const Pinterest = loadable(() => import(`./Svgs/Pinterest`));
const Apple = loadable(() => import(`./Svgs/Apple`));
const Android = loadable(() => import(`./Svgs/Android`));
const UserProfileSvg = loadable(() => import(`./Svgs/v2/User`));
const CartHeaderSvg = loadable(() => import(`./Svgs/v2/Cart`));
const NewCart = loadable(() => import(`./Svgs/v2/NewCart`));
const WishListHeaderSvg = loadable(() => import(`./Svgs/v2/Wishlist`));
const WishListHeaderHighlighted = loadable(() => import(`./Svgs/v2/WishlistHighlighted`));
const NewWishlist = loadable(() => import(`./Svgs/v2/NewWishlist`));
const NewWishlistFilled = loadable(() => import(`./Svgs/v2/NewWishlistFilled`));
const SalesVersion2 = loadable(() => import('./Svgs/v2/Sales'));
const BurgerSvg = loadable(() => import('./Svgs/Burger'));
const BurgerSvg2 = loadable(() => import('./Svgs/v2/Burger'));
const PhoneSvg = loadable(() => import('./Svgs/Phone'));
const EnvelopeSvg = loadable(() => import('./Svgs/Envelope'));
const SaleBadgeSvg = loadable(() => import('./Svgs/SaleBadge'));
const HomeSvg = loadable(() => import('./Svgs/v2/Home'));
const CheckMark = loadable(() => import('./Svgs/v2/CheckMark'));
const VideoPlay = loadable(() => import('./Svgs/v2/Play'));
const VideoPause = loadable(() => import('./Svgs/v2/Pause'));
const DeliveryTruck = loadable(() => import('./Svgs/v2/DeliveryTruck'));
const MoodBoard = loadable(() => import('./Svgs/v2/MoodBoard'));
const Youtube = loadable(() => import('./Svgs/v2/Youtube'));
const StarEmpty = loadable(() => import('./Svgs/StarEmpty'));
const StarHalfFilled = loadable(() => import('./Svgs/StarHalfFilled'));
const StarFilled = loadable(() => import('./Svgs/StarFilled'));
const AlarmClock = loadable(() => import('./Svgs/AlarmClock'));
const Clock = loadable(() => import('./Svgs/Clock'));
const Tick = loadable(() => import('./Svgs/Tick'));
const ClipBoard = loadable(() => import('./Svgs/SkuDiver/ClipBoard'));
const Edit = loadable(() => import('./Svgs/SkuDiver/Edit'));
const PieChart = loadable(() => import('./Svgs/SkuDiver/PieChart'));
const Globe = loadable(() => import('./Svgs/SkuDiver/Globe'));
const Picture = loadable(() => import('./Svgs/SkuDiver/Picture'));
const DeliveryBeforeXmas = loadable(() => import('./Svgs/DeliveryBeforeXmas'));
const Disclaimer = loadable(() => import('./Svgs/Disclaimer'));
const DisclaimerDesktop = loadable(() => import('./Svgs/DisclaimerDesktop'));
const FabricSample = loadable(() => import('./Svgs/FabricSample'));
const AppLogo = loadable(() => import('./Svgs/v2/AppLogo'));

const Svg = {
    account: AccountSvg,
    arrow: ArrowSvg,
    cart: CartSvg,
    categories: CategoriesSvg,
    facebook: FacebookSvg,
    facebook2: Facebook2Svg,
    interiorService: InteriorServiceSvg,
    looks: LooksSvg,
    productFilter: ProductFilterSvg,
    productSortBy: ProductSortBySvg,
    sales: SalesSvg,
    salesV2: SalesVersion2,
    search: SearchSvg,
    search2: SearchSvg2,
    newSearch: NewSearch,
    newWishlist: NewWishlist,
    newWishlistFilled: NewWishlistFilled,
    instagram: Instagram,
    pinterest: Pinterest,
    apple: Apple,
    android: Android,
    userProfile: UserProfileSvg,
    cartHeader: CartHeaderSvg,
    newCart: NewCart,
    wishListHeader: WishListHeaderSvg,
    wishListHeaderHighlighted: WishListHeaderHighlighted,
    burger: BurgerSvg,
    burger2: BurgerSvg2,
    phone: PhoneSvg,
    envelope: EnvelopeSvg,
    saleBadge: SaleBadgeSvg,
    home: HomeSvg,
    clipBoard: ClipBoard,
    checkMark: CheckMark,
    videoPlay: VideoPlay,
    videoPause: VideoPause,
    deliveryTruck: DeliveryTruck,
    moodBoard: MoodBoard,
    youtube: Youtube,
    starEmpty: StarEmpty,
    starHalfFilled: StarHalfFilled,
    starFilled: StarFilled,
    alarmClock: AlarmClock,
    clock: Clock,
    tick: Tick,
    edit: Edit,
    globe: Globe,
    pieChart: PieChart,
    picture: Picture,
    deliveryBeforeXmas: DeliveryBeforeXmas,
    disclaimer: Disclaimer,
    disclaimerDesktop: DisclaimerDesktop,
    fabricSample: FabricSample,
    appLogo: AppLogo,
};

export type SvgType = keyof typeof Svg;

export interface SvgProps extends React.SVGProps<SVGSVGElement> {
    type: SvgType;
    className?: string;
}

/** Lazy load a SVG icon. */
export default ({ type, className, ...props }: SvgProps) => (
    <div className={className}>{React.createElement(Svg[type], props)}</div>
);
